import { Role } from "../../../../models";

export const COUNTY_ROLES = [Role.CountyAdministrator, Role.CountyLeader];

export const INSTITUTION_ROLES = [
  Role.InstitutionPrincipal,
  Role.InstitutionAdministrator,
];

export const ADMIN_ROLES = [Role.CAS, Role.Helpdesk];
